// removed by extract-text-webpack-plugin
module.exports = {"Sidebar":"Sidebar---mC82D"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/conversation/ContactSideBar/Company/style.styl
// module id = LqW9
// module chunks = 89